module.exports = __webpack_public_path__ + "media/images/posts/why_choose_winter_wedding5-33eadac43e458a601efc8bda31473715.jpg";